import React, { useState } from "react";
import axios from "axios";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";


export default function DeleteClassModal({
  cancelModal,
  fetchData,
  selectedClass,
}) {

//  styled

  const [complete, setComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {user} = useAuthContext();

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const deleteResponse = await axios.delete(
        `${ApiConnectionString}/api/pendingEvent/${selectedClass.id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
  
      if (deleteResponse.status == 200) {
     
        setComplete(true);
      }
    } catch (error) {
      console.error("Error deleting the event:", error);
      // You can also handle specific error actions here, like displaying an error message
    } finally {
      setIsLoading(false);
    }
  };
  

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
          <div className="send-modal-footer"></div>
        </div>
      </div>
    );
  } else {
    if (complete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
          <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Class Deleted</p></div> 
    
          <p>The class has been successfully removed.</p>
            <div className="send-modal-footer">
             
            <button
                  onClick={() => {   fetchData();cancelModal()}}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                Okay
                </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
          <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Delete Class</p></div> 


          <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button>
        <div className="d-flex"><span className="red-text mx-2">Class</span> <p>{selectedClass.name}</p></div>  
        <div className="d-flex"><span className="red-text mx-2">Day</span> <p>{selectedClass.day}</p></div>  
        <div className="d-flex"><span className="red-text mx-2">Times</span> <p>{selectedClass.timeIn} - {selectedClass.timeOut}</p></div>  
          <p>Are you sure you want to delete this class?</p>

            <div className="send-modal-footer">
              <button className="saveChanges-button mx-3" onClick={handleDelete}>
          Confirm     
              </button>
              <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
